export enum VisitorState {
  Browsing = 'browsing',
  Chatting = 'chatting',
  Invited = 'invited',
  LeftWebsite = 'left',
  Queued = 'queued',
  Supervised = 'supervised',
  WaitingForReply = 'waiting_for_reply',
}
